import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import {
  getUserAppointments,
  updateAppointmentStatus,
  getDoctorAppointments,
  getHistoryOfPatient,
} from "../api/api";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { hideLoading, showLoading } from "../redux/spinnerSlice";
import moment from "moment";
import { Table, Row } from "antd";

const Appointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [patientHistory, setPatientHistory] = useState([]);
  const dispatch = useDispatch();

  // Fetch User Appointments
  const fetchUserAppointments = async () => {
    try {
      dispatch(showLoading());
      const res = await getUserAppointments();
      setAppointments(res.data);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
    }
  };
  const fetchDoctorAppointments = async () => {
    try {
      dispatch(showLoading());
      const res = await getDoctorAppointments();
      setAppointments(res.data);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      console.log(err);
    }
  };
  const handleStatus = async (record, status) => {
    try {
      const appointmentsId = record._id;
      const data = { appointmentsId, status };
      dispatch(showLoading());
      const response = await updateAppointmentStatus(data);
      if (response.success) {
        toast.success(response.message);
        fetchDoctorAppointments();
      }
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };
  useEffect(() => {
    fetchUserAppointments();

    fetchDoctorAppointments();
  }, []);
  const handleDetails = async (record, status) => {
    try {
      const pname = record.pname;
      const data = { pname };
      dispatch(showLoading());
      const response = await getHistoryOfPatient(data);
      if (response.success) {
        toast.success(response.message);
        setPatientHistory(response.data);
        console.log(JSON.stringify(response.data));
        fetchDoctorAppointments();
      }
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };
  //Create antd table
  const columns = [
    {
      title: "MR No",
      dataIndex: ["mrNo"],
      key: "mrNo",
    },
    {
      title: "Doctor Name",
      dataIndex: "name",
      render: (text, record) => (
        <span>
          {record.doctorInfo.firstName} {record.doctorInfo.lastName}
        </span>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
      render: (text, record) => <span>{record.doctorInfo.department}</span>,
    },
    {
      title: "Experience",
      dataIndex: "experience",
      render: (text, record) => <span>{record.doctorInfo.experience}</span>,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (text, record) => <span>{record.doctorInfo.phoneNumber}</span>,
    },
    {
      title: "Date & Time",
      dataIndex: "date",
      render: (text, record) => (
        <span>
          {moment(record.date).format("DD-MM-YYYY")} &nbsp;
          {moment(record.time).format("HH:mm A")}
        </span>
      ),
    },
    
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <span style={{ color: text === "APPROVE" ? "green" :text === "rejected" ? "red":"green", textTransform: "uppercase" }}>
          {text}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="d-flex">
          <button
            className="btn btn-success mx-2"
            onClick={() => handleDetails(record, "approved")}
          >
            Show History
          </button>
          {record.status === "pending" && (

            <div className="d-flex">

              <button
                className="btn btn-success mx-2"
                onClick={() => handleStatus(record, "approved")}
              >
                Approved
              </button>
              <button
                className="btn btn-danger"
                onClick={() => handleStatus(record, "rejected")}
              >
                Reject
              </button>
            </div>
          )}
        </div>
      ),
    },
  ];
  const patientHistoryColumns = [
    {
      title: "MR No",
      dataIndex: ["mrNo"],
      key: "mrNo",
    },
    {
      title: "Doctor Name",
      dataIndex: ["doctorInfo", "firstName"],
      key: "doctorName",
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
    {
      title: "Patient Name",
      dataIndex: "pname",
      key: "pname",
    },
    {
      title: "Test Name",
      dataIndex: "testname",
      key: "testname",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Last Visit",
      dataIndex: "lastVisit",
      key: "lastVisit",
      render: (date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (time) => moment(time, "ddd MMM DD YYYY HH:mm:ss").format("hh:mm A"),
    },
  ];
  return (
    <Layout>
      <div className="table-responsive">
        <h1 className="m-4 text-center">Appointments List</h1>
        <Table
          className="mt-3"
          columns={columns}
          dataSource={appointments}
          rowKey={(record) => record._id}
          scroll={{ x: "max-content" }}
        />
      </div>
      <div className="table-responsive">
        <h1 className="m-4 text-center">Appointments List</h1>
        {patientHistory.length > 0 && (
          <><h2>Patient History</h2><Row>
            <br></br>
            <br></br>
            <Table dataSource={patientHistory} columns={patientHistoryColumns} /> {/* Render appointment data in a table */}
          </Row></>)}
      </div>
    </Layout>
  );
};

export default Appointments;
